module.exports = __webpack_public_path__ + "img/section3Logo1.202a00c1.svg";